import { module } from 'modujs';

export default class Accordion extends module {

    static get settings() {
        return {
            CLASS_OPEN: 'is-open',
        }
    }

    constructor(m) {
        super(m);

        // DOM Elements
        this.$el = this.el
        this.$container = this.$('container')[0]
        this.$content = this.$('content')[0]
        this.$toggler = this.$('toggler')[0]

        // Opened state if data-accordion-opened
        this.isOpen = this.getData('opened') !== null

        // Events
        this.events = {
            click: {
                'toggler': 'toggle'
            },
        }
    }

    init() {

        // Set sizes
        this.resize()

        // Default opened
        if(this.isOpen) {
            this.open()
        }

        // Bind keyboard events
        this.$toggler.addEventListener('keydown', this.onKeydown = e => {
            if(e.code === 'Space' || e.code === 'Enter') {
                this.toggle()
            }
        })

        // Add window event
        window.addEventListener('resize', this.onResize = () => this.resize())
    }

    toggle() {

        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.$el.classList.add(Accordion.settings.CLASS_OPEN)
        this.isOpen = true
        this.$toggler.setAttribute('aria-expanded', 'true')

        // Clear close callback
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }

        // Set open callback
        this.openTimeout = setTimeout(() => {
        }, this.duration)
    }

    close() {
        this.$el.classList.remove(Accordion.settings.CLASS_OPEN)
        this.isOpen = false
        this.$toggler.setAttribute('aria-expanded', 'false')

        // Clear open callback
        if (this.openTimeout) {
            clearTimeout(this.openTimeout);
        }

        // Set close callback
        this.closeTimeout = setTimeout(() => {
        }, this.duration);
    }

    resize() {
        // Set content height
        const height = this.$content.offsetHeight
        this.$el.style.setProperty('--accordion-container-height', `${height}px`)

        // Get styles
        const duration = window.getComputedStyle(this.$el).getPropertyValue('--accordion-duration');
        this.$container.style.setProperty('--accordion-duration', duration);
        this.duration = 1000 * parseInt(duration, 10);

        // console.log(this.duration)
    }

    destroy() {

        // Unbind keyboard events
        this.$toggler.removeEventListener('keydown', this.onKeydown)

        // Remove window event
        window.removeEventListener('resize', this.onResize)
    }
}
